module.exports = __webpack_public_path__ + "img/1.64043cf6.svg";